import React from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { useLang } from "@/i18n";
import { track, waLink } from "@/lib/api";
import { useSettings } from "@/lib/settings";

export default function Footer() {
  const { t } = useLang();
  const navigate = useNavigate();
  const s = useSettings();

  return (
    <footer className="bg-[#121316] text-[#FAF8F5] relative overflow-hidden grain">
      <div className="chela-container py-14 sm:py-20 relative">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo dark size="text-3xl" />
            <p className="mt-4 text-lg text-white/70 max-w-sm">{t("foot_tag")}</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                data-testid="footer-book-btn"
                onClick={() => { track("book_click", { source: "footer" }); navigate("/book"); }}
                className="inline-flex items-center h-11 px-6 rounded-full btn-saffron text-sm font-bold"
              >
                {t("book")}
              </button>
              <button
                data-testid="footer-whatsapp-btn"
                onClick={() => { track("whatsapp_click", { source: "footer" }); window.open(waLink("Hi CHELA! I'd like to book an extra pair of hands."), "_blank"); }}
                className="inline-flex items-center gap-2 h-11 px-6 rounded-full btn-whatsapp text-sm font-bold"
              >
                <MessageCircle size={16} /> {t("whatsapp")}
              </button>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8 text-sm">
            <div>
              <div className="text-white/40 font-bold uppercase tracking-wider text-xs mb-4">CHELA</div>
              <button onClick={() => navigate("/book")} className="block py-1.5 text-white/70 hover:text-white">{t("book")}</button>
              <button onClick={() => navigate("/partner")} className="block py-1.5 text-white/70 hover:text-white">{t("nav_partner")}</button>
              <button onClick={() => navigate("/#faq")} className="block py-1.5 text-white/70 hover:text-white">{t("nav_faq")}</button>
              <button data-testid="footer-join-link" onClick={() => navigate("/join")} className="block py-1.5 text-white/70 hover:text-white">{t("foot_join")}</button>
            </div>
            <div>
              <div className="text-white/40 font-bold uppercase tracking-wider text-xs mb-4">Legal</div>
              <button onClick={() => navigate("/terms")} className="block py-1.5 text-white/70 hover:text-white">{t("terms")}</button>
              <button onClick={() => navigate("/privacy")} className="block py-1.5 text-white/70 hover:text-white">{t("privacy")}</button>
              <button onClick={() => navigate("/safety")} className="block py-1.5 text-white/70 hover:text-white">{t("safety")}</button>
            </div>
            <div>
              <div className="text-white/40 font-bold uppercase tracking-wider text-xs mb-4">Reach us</div>
              <a href={waLink("Hi CHELA!")} target="_blank" rel="noreferrer" className="block py-1.5 text-white/70 hover:text-white">WhatsApp</a>
              <a data-testid="footer-email" href={`mailto:${s.business_email}`} className="block py-1.5 text-white/70 hover:text-white break-all">{s.business_email}</a>
            </div>
          </div>
        </div>

        <p className="mt-12 text-xs text-white/40 max-w-3xl leading-relaxed">{t("foot_disclaimer")}</p>
        <p data-testid="footer-address" className="mt-4 text-sm text-white/60">{t("foot_address")}</p>
        <p className="mt-2 text-xs text-white/40">© {new Date().getFullYear()} {t("foot_rights")}</p>
      </div>
    </footer>
  );
}
